import * as SwitchPrimitive from '@radix-ui/react-switch'
import { forwardRef } from 'react'

interface SwitchProps {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
}

const Switch = forwardRef<HTMLButtonElement, SwitchProps>(
  ({ checked, onCheckedChange, disabled }, ref) => {
    return (
      <SwitchPrimitive.Root
        ref={ref}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        className="relative w-11 h-6 rounded-full transition-colors bg-muted-foreground/30 data-[state=checked]:bg-primary disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <SwitchPrimitive.Thumb className="block w-5 h-5 bg-white rounded-full shadow transition-transform translate-x-0.5 data-[state=checked]:translate-x-[22px]" />
      </SwitchPrimitive.Root>
    )
  }
)

Switch.displayName = 'Switch'

export { Switch }
